import React, { useEffect, useState } from 'react';
import Card from './components/Card';
import DescModal from './components/DescModal';
import './css/card.css';
// import products from './product.json';

const App = () => {
  const [prod, setProd] = useState();
  const [mod, setModl] = useState(null);
  useEffect(() => {
    setTimeout(async () => {
      if (process.env.NODE_ENV === 'development') {
        const products = await import('./product.json');
        console.log(products);
        setProd(products.default);
      } else {
        setProd(window.products);
      }
    }, 500);
    console.log(process.env.NODE_ENV);
  }, []);
  useEffect(() => {
    if (mod !== null) {
      document.querySelector('body').style.overflowY = 'hidden';
    } else {
      document.querySelector('body').style.overflowY = 'scroll';
    }
  }, [mod]);
  return (
    <>
      <Card products={prod} setMod={setModl} />
      <DescModal prod={mod} setMod={setModl} />
    </>
  );
};

export default App;
